/*!
 * lhx-rail-ga4.js — mide el rail «En movimiento» (lhx-video-rail + lhx-video-player).
 *
 * POR QUÉ EXISTE (08/09/2026). Martin preguntó si el rail trae ventas y no se podía responder:
 * la sección no emitía NADA. La tarjeta es un <button> con data-url —no un <a href>—, así que
 * para GA4 y para Shopify abrir el reproductor no existe; y los "Ver producto" / "Agregar" que
 * viven DENTRO del reproductor eran indistinguibles de cualquier otro click de la home.
 *
 * QUÉ HACE. Escuchas DELEGADAS en `document`, sin tocar `lhx-video-player.js` (12 KB) ni la
 * sección. Manda 3 eventos ESTÁNDAR de GA4 con `item_list_name`, que es lo que alimenta el
 * informe nativo "rendimiento de lista de artículos" — sin pedir configuración en GA4, que es
 * justo lo que no podemos hacer (el service account es solo Lector).
 *
 *   view_item_list  el rail entra en pantalla        (una vez por carga)
 *   select_item     click en "Ver producto"
 *   add_to_cart     click en "Agregar"
 *
 * 🪤 El `item_id` sale de `data-variante` de la TARJETA, no del reproductor: el reproductor no
 *    lleva ids. Se cruza tarjeta↔slide por la URL del producto. Se usa el id de VARIANTE porque
 *    es el que manda la integración GA4 de Shopify en `purchase`; si se usara el handle, el
 *    informe no cruzaría con las compras y el número no serviría.
 * 🪤 `gtag` puede no estar listo cuando el usuario hace click: se encola y se vacía al aparecer.
 * ⚠️ Esto mide CLICKS y ADD-TO-CART con toda confianza. La atribución de INGRESO depende de que
 *    el `item_id` cruce con el `purchase` de Shopify — hay que confirmarlo con datos reales
 *    antes de citar plata.
 */
(function () {
  'use strict';
  if (window.__lhxRailGa4) return;           // idempotente: dos copias no duplican eventos
  window.__lhxRailGa4 = true;

  var LISTA = 'En movimiento';
  var LISTA_ID = 'rail_video';
  var cola = [];

  function enviar(evento, params) {
    if (typeof window.gtag === 'function') { window.gtag('event', evento, params); return; }
    cola.push([evento, params]);
    if (cola.length === 1) {
      var intentos = 0;
      var t = setInterval(function () {
        intentos++;
        if (typeof window.gtag === 'function') {
          clearInterval(t);
          cola.forEach(function (x) { window.gtag('event', x[0], x[1]); });
          cola = [];
        } else if (intentos > 40) { clearInterval(t); cola = []; }   // 20 s y se rinde
      }, 500);
    }
  }

  /* /products/x?variant=1&algo -> /products/x  — el reproductor y la tarjeta no siempre coinciden */
  function ruta(href) {
    if (!href) return '';
    try { return new URL(href, location.origin).pathname.replace(/\/+$/, ''); }
    catch (e) { return String(href).split('?')[0].replace(/\/+$/, ''); }
  }

  /* Las tarjetas del rail son la ÚNICA fuente de ids: el reproductor no los lleva. */
  function catalogo() {
    var m = {};
    document.querySelectorAll('[data-lhx-rail-item]').forEach(function (b, i) {
      var k = ruta(b.getAttribute('data-url'));
      if (!k) return;
      m[k] = {
        item_id: b.getAttribute('data-variante') || k,
        item_name: b.getAttribute('data-titulo') || '',
        price: precio(b.getAttribute('data-precio')),
        index: i
      };
    });
    return m;
  }

  /* "$37,990" -> 37990. Shopify escribe el separador de miles según el idioma de la tienda. */
  function precio(txt) {
    if (!txt) return undefined;
    var n = parseFloat(String(txt).replace(/[^\d]/g, ''));
    return isNaN(n) ? undefined : n;
  }

  function itemDe(href) {
    var m = catalogo();
    var it = m[ruta(href)];
    if (!it) return null;
    return {
      item_id: it.item_id,
      item_name: it.item_name,
      price: it.price,
      index: it.index,
      item_list_id: LISTA_ID,
      item_list_name: LISTA
    };
  }

  /* ── 1. view_item_list: el rail entró en pantalla ─────────────────────────── */
  function observarRail() {
    var rail = document.querySelector('[data-lhx-rail-item]');
    rail = rail && rail.closest('.shopify-section, section');
    if (!rail || !('IntersectionObserver' in window)) return;
    var visto = false;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (!e.isIntersecting || visto) return;
        visto = true;
        io.disconnect();
        var m = catalogo();
        var items = Object.keys(m).map(function (k) {
          return {
            item_id: m[k].item_id, item_name: m[k].item_name, price: m[k].price,
            index: m[k].index, item_list_id: LISTA_ID, item_list_name: LISTA
          };
        });
        if (items.length) {
          enviar('view_item_list', { item_list_id: LISTA_ID, item_list_name: LISTA, items: items });
        }
      });
    }, { threshold: 0.3 });
    io.observe(rail);
  }

  /* ── 2 y 3. clicks dentro del reproductor ─────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* "Ver producto" — es un <a href> real dentro del slide */
    var link = t.closest('.lhx-pl a[href*="/products/"]');
    if (link) {
      var it = itemDe(link.getAttribute('href'));
      if (it) enviar('select_item', { item_list_id: LISTA_ID, item_list_name: LISTA, items: [it] });
      return;
    }

    /* "Agregar" — botón sin href: el producto sale del enlace de SU MISMO slide */
    var btn = t.closest('.lhx-pl__btn--solido');
    if (btn) {
      var slide = btn.closest('.lhx-pl__slide');
      var a = slide && slide.querySelector('a[href*="/products/"]');
      var it2 = a && itemDe(a.getAttribute('href'));
      if (it2) {
        enviar('add_to_cart', {
          currency: 'CLP',
          value: it2.price,
          items: [{ item_id: it2.item_id, item_name: it2.item_name, price: it2.price,
                    quantity: 1, item_list_id: LISTA_ID, item_list_name: LISTA }]
        });
      }
      return;
    }

    /* abrir el reproductor: señal de uso, no de venta. Evento propio, no estándar. */
    var card = t.closest('[data-lhx-rail-item]');
    if (card) {
      var it3 = itemDe(card.getAttribute('data-url'));
      enviar('rail_video_abre', {
        item_list_id: LISTA_ID, item_list_name: LISTA,
        item_id: it3 ? it3.item_id : undefined,
        item_name: it3 ? it3.item_name : undefined
      });
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observarRail);
  } else { observarRail(); }
})();
